import template from "./quick-setup.html";
import controller from "./quick-setup.controller";
import "./quick-setup.scss";

const QuickSetupComponent = {
    template,
    controller,
    controllerAs: "ctrl"
};

export default QuickSetupComponent;


// WEBPACK FOOTER //
// ./sources/components/configurations/quick-setup/quick-setup.component.js